import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class AccountMenuService {
  private translateService = inject(TranslateService);

  private readonly menuItems = signal([
    {
      separator: true,
    },
    {
      id: 'profile',
      label: this.translateService.instant('common.profile'),
      icon: 'pi pi-user',
      linkClass: '!text-black-500 dark:!text-black-400',
    },
    {
      id: 'signOut',
      label: this.translateService.instant('common.signOut'),
      icon: 'pi pi-sign-out',
      linkClass: '!text-red-500 dark:!text-red-400',
    },
  ]);

  getAccountMenuItems(): WritableSignal<MenuItem[]> {
    return this.menuItems;
  }

  setMenuItemCommand(id: string, command: () => void): void {
    this.menuItems.update((items) =>
      items.map((item) => (item.id === id ? { ...item, command } : item)),
    );
  }
}
